import React from "react";
import { FiGift } from "react-icons/fi";

const Referrals: React.FC = () => {
  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#fafbfc",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div style={{ textAlign: "center", padding: "40px", maxWidth: "500px" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
          <div style={{ width: "80px", height: "80px", borderRadius: "50%", background: "#fef3c7", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <FiGift size={40} color="#d97706" />
          </div>
        </div>
        <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "#1f2937", marginBottom: "12px" }}>
          Referrals is Coming Soon
        </h2>
        <p style={{ fontSize: "16px", color: "#6b7280", lineHeight: "1.5" }}>
          Soon you'll be able to refer friends and earn rewards. Stay tuned for updates!
        </p>
      </div>
    </div>
  );
};

export default Referrals;
